import {bugsnagClient} from "../navigation/ReduxProvider";
import Toast from "../components/helper/Toast";
import {Environment} from "../model/settings/Settings";
import {ExternalServiceError, ExternalServiceErrorType} from "../model/externalServiceError/ExternalServiceError";
import JsonUtils from "./JsonUtils";

export function isDefined(object: any) {
	return object !== undefined && object !== null;
}

/**
 * Indicates if the screen is a phone's. Fields don't take the focus on their own there, because it opens
 * the keyboard over half of the page.
 */
export function isPhoneScreen() {
	return !!window.matchMedia && window.matchMedia("(max-width: 640px)").matches;
}

/**
 * Check if occured error is Xero or Revolut exception.
 * @param error
 */
function isExternalServiceError(error: any) {
	const externalServiceErrors = [ExternalServiceErrorType.XeroError, ExternalServiceErrorType.RevolutError];
	return error
		&& error.response
		&& error.response.data
		&& externalServiceErrors.some(errorType => error.response.data.exception === errorType);
}

export function getErrorMessage(error: any): string | undefined {
	if (error && error.response && error.response.data && error.response.data.message) {
		return error.response.data.message
	}
	return undefined
}

/**
 * Console log error if environment is not production.
 * @param error
 */
export function logErrorOnDevEnvironment(error: any) {
	if (process.env.NODE_ENV !== Environment.Production) {
		console.error(error);
	}
}

export function notifyBugsnagAndShowToast(error: any, title: string, message?: string) {
	notifyBugsnag(error);
	let detailedMessage;
	if (isExternalServiceError(error)) {
		const json = JsonUtils.parse(error.response.data.message);
		if (json) {
			try {
				const externalServiceError = ExternalServiceError.fromJson(json, error.response.data.exception);
				detailedMessage = externalServiceError.getErrorMessage();
			}
			catch (e) {
				logErrorOnDevEnvironment(e);
			}
		}
	}
	Toast.error(message || detailedMessage || "Sorry, something went wrong. Try again later.", title);
	logErrorOnDevEnvironment(error);
}

export const notifyBugsnag = (error: any) => {
	if (error && error.config && error.config.url) {
		bugsnagClient.notify(error, {
				metaData: {
					response: {
						code: error.code,
						error: error.response && error.response.data.error,
						errors: error.response && error.response.data.errors,
						message: JSON.stringify(
							{errorMessage: error.message, errorResponseMessage: error.response && error.response.data.message}),
						method: error.config.method && error.config.method.toUpperCase(),
						status: error.response && error.response.status,
						url: error.config.url
					}
				}
			}
		)
	}
	else {
		bugsnagClient.notify(error)
	}
};